if (!customElements.get('finch-dynamic-collection')) {
  class FinchDynamicCollection extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-fdc-track]');
      this.previousButton = this.querySelector('[data-fdc-previous]');
      this.nextButton = this.querySelector('[data-fdc-next]');

      if (!this.track) return;

      this.handlePrevious = () => this.scrollByCard(-1);
      this.handleNext = () => this.scrollByCard(1);
      this.handleScroll = () => this.scheduleUpdate();
      this.handleResize = () => this.scheduleUpdate();

      this.previousButton?.addEventListener('click', this.handlePrevious);
      this.nextButton?.addEventListener('click', this.handleNext);
      this.track.addEventListener('scroll', this.handleScroll, { passive: true });

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.handleResize);
        this.resizeObserver.observe(this.track);
      } else {
        window.addEventListener('resize', this.handleResize);
      }

      this.scheduleUpdate();
    }

    disconnectedCallback() {
      this.previousButton?.removeEventListener('click', this.handlePrevious);
      this.nextButton?.removeEventListener('click', this.handleNext);
      this.track?.removeEventListener('scroll', this.handleScroll);
      this.resizeObserver?.disconnect();
      window.removeEventListener('resize', this.handleResize);

      if (this.updateFrame) cancelAnimationFrame(this.updateFrame);
    }

    scheduleUpdate() {
      if (this.updateFrame) cancelAnimationFrame(this.updateFrame);
      this.updateFrame = requestAnimationFrame(() => {
        this.updateFrame = null;
        this.updateControls();
      });
    }

    scrollByCard(direction) {
      const card = this.track.querySelector('.fdc__card');
      const styles = getComputedStyle(this.track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
      const distance = (card?.getBoundingClientRect().width || this.track.clientWidth * 0.8) + gap;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.track.scrollBy({
        left: distance * direction,
        behavior: reducedMotion ? 'auto' : 'smooth',
      });
    }

    updateControls() {
      const maximumScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const currentScroll = Math.abs(this.track.scrollLeft);
      const isScrollable = maximumScroll > 2;
      const firstMedia = this.track.querySelector('.fdc__media');

      if (firstMedia) {
        this.style.setProperty('--fdc-control-top', `${firstMedia.getBoundingClientRect().height / 2}px`);
      }

      this.dataset.scrollable = String(isScrollable);

      if (this.previousButton) this.previousButton.disabled = !isScrollable || currentScroll <= 2;
      if (this.nextButton) this.nextButton.disabled = !isScrollable || currentScroll >= maximumScroll - 2;
    }
  }

  customElements.define('finch-dynamic-collection', FinchDynamicCollection);
}
